import { openKakaoLink } from '../utils';
import { TextVariant } from './types';

export const OFFLINE_INFO_CONSTANTS: Record<string, TextVariant> = {
  fullText: {
    common: <>NLH Main Event Day 1</>,
  },
  titleHolder: { common: '오프라인 이벤트 참가권 소지자' },
  venue: { common: '뉴스톤' },
  venueAddress: { common: '서울 강남구 도곡로 1길 14 지하 1층 6, 7호' },
  eventDate: { common: '4월 5일(일)' },
  entryTime: { common: '오후 1시 부터 입장이 가능합니다.' },
  warningTicket: { common: '사용하지 않는 참가권은 이벤트 종료 후 소멸됩니다.' },
  detailInfo: {
    common: (
      <>
        자세한 내용은 <span onClick={openKakaoLink}>JOPT 카카오톡 채널</span>에 문의해주세요!
      </>
    ),
  },
};
